import { SelectedAgencyShortDataDocument } from '../../graphql/graphql';

export const getSelectedAgencyShortDataQuery = SelectedAgencyShortDataDocument;
